import { useEffect, useState } from 'react';
import Breadcrumb from '../common/Breadcrumb';

// ================================================================
// Branch Data – grouped by Board
// ================================================================
const branchData = {
  CBSE: [
    {
      id: 1,
      name: 'Eldeco Colony Branch',
      board: 'CBSE',
      image: '/images/gallery/eldeco_collony.png',
      alt: 'Pioneer Montessori Inter College - Eldeco Colony (CBSE)',
      address: 'Sector-3, Udyan-1, Eldeco Colony, Lucknow',
      classes: 'Montessori to 12th',
      principal: 'Mrs. Sharmila Singh',
      phones: ['+91 522-2446377', '+91 522-2447730'],
      email: 'pmseldeco@rediffmail.com',
      website: 'http://www.pmiceldeco.in',
    }
  ],

  ICSE: [
    {
      id: 2,
      name: 'JANKIPURAM BRANCH',
      board: 'ICSE',
      image: '/images/jankipuram-icsc.jpg',
      alt: 'Pioneer Montessori Inter College - Jankipuram (ICSE)',
      address: 'Sector-I, 60 Feet Rd, Jankipuram',
      classes: 'Mont. to 12th',
      principal: 'Mrs. Farah Kazmi',
      phones: ['+91 7881196969'],
      email: 'pms1234jkpac@gmail.com',
      website: 'http://www.pioneermontessori.in/Jankipuram',
    },
    {
      id: 3,
      name: 'VIKAS NAGAR BRANCH',
      board: 'ICSE',
      image: '/images/vikashnagar-icsc.jpg',
      alt: 'Pioneer Montessori Inter College - Vikas Nagar (ICSE)',
      address: 'Sector 1, Kursi Road, Vikas Nagar',
      classes: 'Mont. to 12th',
      principal: 'Dr. Archana Singh',
      phones: ['+91 522-2738420'],
      email: 'pms.college1@gmail.com',
      website: 'http://www.pioneermontessori.in/VikasNagar',
    },
  ],

  UP: [
    {
      id: 101,
      name: 'Indrani Nagar Branch',
      board: 'UP Board',
      image: '/images/indrani-nagar.jpg',
      alt: 'Pioneer Montessori Inter College - Indrani Nagar (UP Board)',
      address: 'Indrani Nagar, Kundri Rakabganj, Lucknow',
      classes: 'Mont. to 12th',
      principal: 'Mrs. Namita Pandey',
      phones: ['+91 522-2653501', '+91 522-4315548'],
      email: 'pmsicindraningr@yahoo.com',
      website: 'http://www.pioneermontessori.in/IndraniNagar',
    },
    {
      id: 102,
      name: 'Rajajipuram Branch',
      board: 'UP Board',
      image: '/images/rajaji-puram.jpg',
      alt: 'Pioneer Montessori Inter College - Rajajipuram C-4746',
      address: 'C-4746, Rajajipuram, Lucknow',
      classes: 'Mont. to 10th',
      principal: 'Mrs. Indu Gaur',
      phones: ['+91 522-2410382', '+91 522-6570176'],
      email: 'pms4746rjpm@gmail.com',
      website: '',
    },
    {
      id: 103,
      name: 'Rajajipuram Branch',
      board: 'UP Board',
      image: '/images/rajaji-puram-2.jpg',
      alt: 'Pioneer Montessori Inter College - Rajajipuram C-18',
      address: 'C-18, Rajajipuram, Lucknow',
      classes: 'Mont. to 8th',
      principal: 'Mrs. Gargi Arya',
      phones: ['+91 522-2418784'],
      email: '18pmsrjpm@gmail.com',
      website: '',
    },
    {
      id: 104,
      name: 'Rajendra Nagar Branch',
      board: 'UP Board',
      image: '/images/rajendra-nagar.jpg',
      alt: 'Pioneer Montessori Inter College - Rajendra Nagar 206',
      address: '206, Rajendra Nagar, Lucknow',
      classes: '11th to 12th',
      principal: 'Mrs. Usha Suri',
      phones: ['+91 522-2693725', '+91 522-4335657'],
      email: 'pmsicrn206@gmail.com',
      website: '',
    },
    {
      id: 105,
      name: 'Rajendra Nagar Branch',
      board: 'UP Board',
      image: '/images/rajendra-nagar-2.jpg',
      alt: 'Pioneer Montessori Inter College - Rajendra Nagar 338',
      address: '338, Rajendra Nagar, Lucknow',
      classes: 'Mont. to 12th',
      principal: 'Mrs. Anjana Malviya',
      phones: ['+91 522-2693724', '+91 522-4245927'],
      email: 'pmseng.rajendranagar@gmail.com',
      website: 'http://www.pioneermontessori.in/RajendraNagar',
    },
    {
      id: 106,
      name: 'Rajendra Nagar Junior Section',
      board: 'UP Board',
      image: '/images/rajendra-nagar-3.jpg',
      alt: 'Pioneer Montessori Inter College - Rajendra Nagar Junior',
      address: '227, Rajendra Nagar, Lucknow',
      classes: 'Mont. to 8th',
      principal: 'Mrs. Sandhya Dwivedi',
      phones: ['+91 522-2691645', '+91 522-4305825'],
      email: 'pmicrn206@gmail.com',
      website: '',
    },
    {
      id: 107,
      name: 'Bagh Sher Jung Branch',
      board: 'UP Board',
      image: '/images/subhash-nagar.jpg',
      alt: 'Pioneer Montessori Inter College - Bagh Sher Jung',
      address: 'Subash Marg, Bagh Sher Jung, Lucknow',
      classes: 'Mont. to 8th',
      principal: 'Miss. Jaya',
      phones: ['+91 522-2265341'],
      email: 'pmsbjb@gmail.com',
      website: '',
    },
    {
      id: 108,
      name: 'Geetapalli Branch',
      board: 'UP Board',
      image: '/images/geetapalli.jpg',
      alt: 'Pioneer Montessori Inter College - Geetapalli',
      address: 'Near Sujanpura, Alambagh, Lucknow',
      classes: 'Mont. to 12th',
      principal: 'Mrs. Preeti Dixit',
      phones: ['+91 522-2453812'],
      email: 'pmsgeetapalli@gmail.com',
      website: '',
    },
    {
      id: 109,
      name: 'Water Works Branch',
      board: 'UP Board',
      image: '/images/aishbag.jpg',
      alt: 'Pioneer Montessori Inter College - Water Works',
      address: 'Water Works Road, Aishbagh, Lucknow',
      classes: 'Mont. to 8th',
      principal: 'Miss. Vandana Sharma',
      phones: ['+91 522-2654345'],
      email: 'pmswwrd.2022@gmail.com',
      website: '',
    },
    {
      id: 110,
      name: 'PS Kids Galaxy',
      board: 'UP Board',
      image: '/images/galaxy.jpg',
      alt: 'PS Kids Galaxy - Eldeco (Pre-Primary)',
      address: 'Sector-2, Udyan-1, Eldeco Colony, Lucknow',
      classes: 'Pre Primary',
      principal: 'Mrs. Shruti Dixit',
      phones: ['+91 522-4586546'],
      email: 'info@pskidsgalaxy.in',
      website: 'http://www.pskidsgalaxy.in',
    },
    {
      id: 111,
      name: 'Satyapremi Nagar Branch (Barabanki)',
      board: 'UP Board',
      image: '/images/satyapreminagar.jpg',
      alt: 'Pioneer Montessori Inter College - Satyapremi Nagar, Barabanki',
      address: 'Near Chhaya Cinema, Barabanki',
      classes: 'Mont. to 10th',
      principal: 'Mrs. Arunima Singh Panwar',
      phones: ['+91 5248-297266'],
      email: 'pioneer.spn@rediffmail.com',
      website: 'http://www.pioneermontessori.in/SatyapremiNagar',
    },
    {
      id: 112,
      name: 'Lakhperabagh Branch (Barabanki)',
      board: 'UP Board',
      image: '/images/lakhpedabagh.jpg',
      alt: 'Pioneer Montessori Inter College - Lakhperabagh, Barabanki',
      address: 'Lakhperabagh, Barabanki',
      classes: 'Mont. to 12th',
      principal: 'Mrs. Sonika Mishra',
      phones: ['+91 5248-223533'],
      email: 'pmicbbklb@gmail.com',
      website: 'http://www.pioneermontessori.in/Lakhpedabagh',
    },
  ],
};

// ================================================================
// Reusable Branch Card Component – Fixed & Safe
// ================================================================
const BranchCard = ({ branch }) => {
  const getWebsiteDisplay = () => {
    if (!branch.website || branch.website.trim() === '') {
      return <span className="text-muted">Not available</span>;
    }

    try {
      const url = new URL(branch.website.startsWith('http') ? branch.website : `http://${branch.website}`);
      const hostname = url.hostname.replace(/^www\./, '');
      return (
        <a href={branch.website} target="_blank" rel="noopener noreferrer" className="text-primary">
          {hostname}
        </a>
      );
    } catch (e) {
      return <a href={branch.website} target="_blank" rel="noopener noreferrer" className="text-primary">
        {branch.website}
      </a>;
    }
  };

  return (
    <div className="location-content mb-5">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
          <div className="school-image-container">
            <img
              src={branch.image}
              alt={branch.alt}
              className="school-image img-fluid rounded shadow"
            />
          </div>
        </div>

        {/* Details */}
        <div className="col-lg-6 col-md-12">
          <div className="details-card">
            <h2 className="h4 mb-3">{branch.name.toUpperCase()}</h2>
            <div className="badge bg-primary text-white mb-4 px-3 py-2">{branch.board} Board</div>

            <div className="detail-row">
              <div className="detail-label fw-bold text-secondary">Address</div>
              <div className="detail-value">{branch.address}</div>
            </div>

            <div className="detail-row">
              <div className="detail-label fw-bold text-secondary">Classes</div>
              <div className="detail-value">{branch.classes}</div>
            </div>

            <div className="detail-row">
              <div className="detail-label fw-bold text-secondary">Principal</div>
              <div className="detail-value">{branch.principal}</div>
            </div>

            <div className="detail-row">
              <div className="detail-label fw-bold text-secondary">Telephone</div>
              <div className="detail-value">
                {branch.phones.map((phone, idx) => (
                  <span key={idx}>
                    <a href={`tel:${phone.replace(/[^+\d]/g, '')}`} className="text-primary me-2">
                      {phone}
                    </a>
                    {idx < branch.phones.length - 1 && <span className="text-muted">|</span>}
                  </span>
                ))}
              </div>
            </div>

            <div className="detail-row">
              <div className="detail-label fw-bold text-secondary">E-mail</div>
              <div className="detail-value">
                <a href={`mailto:${branch.email}`} className="text-primary">
                  {branch.email}
                </a>
              </div>
            </div>

            <div className="detail-row mb-3">
              <div className="detail-label fw-bold text-secondary">Website</div>
              <div className="detail-value">
                {getWebsiteDisplay()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ================================================================
// Main Branches Page Component
// ================================================================
const Branches = () => {
  const [activeTab, setActiveTab] = useState('CBSE');

  useEffect(() => {
    document.title = 'Our Branches | Pioneer Montessori Inter College';
  }, []);

  const tabs = [
    { key: 'CBSE', label: 'CBSE Board' },
    { key: 'ICSE', label: 'ICSE Board' },
    { key: 'UP',   label: 'UP Board' },
  ];

  return (
    <>
      <Breadcrumb
        pageTitle="Our Branches"
        breadcrumbItems={[
          { label: 'Home', link: '/' },
          { label: 'Our Branches' },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <div className="location-page py-5 bg-light">
        <div className="dot-pattern-left"></div>
        <div className="dot-pattern-right"></div>

        <div className="container">
          {/* Header */}
          <div className="location-header text-center mb-5">
            <h2 class="title"><span class="text-primary">Our Branches</span></h2>
            <div className="curved-line mx-auto mt-3"></div>
          </div>

          {/* Tabs */}
          <div className="text-center mb-5">
            <div className="branch-tabs d-inline-flex flex-wrap gap-3">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`btn px-4 py-2 rounded-pill ${activeTab === tab.key
                      ? 'btn-primary text-white'
                      : 'btn-outline-primary'
                    }`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                  <span className="ms-2 badge rounded-pill bg-light text-dark">
                    {branchData[tab.key].length}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Branch List */}
          <div className="branches-container">
            {branchData[activeTab].length > 0 ? (
              branchData[activeTab].map((branch) => (
                <BranchCard key={branch.id} branch={branch} />
              ))
            ) : (
              <div className="text-center py-5">
                <p className="text-muted fs-5">No branches available under this board yet.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Branches;